import { Box, MenuItem, Stack, TextField } from '@mui/material';
import { SearchField } from '../../../components/DataTable';
import type { ListParams } from '../lib/useListParams';

/** Search, status and date-range filters for document lists. */
export function ListToolbar({
  params,
  set,
  statuses,
  placeholder,
}: {
  params: ListParams;
  set: (patch: Partial<ListParams>) => void;
  statuses: { value: string; label: string }[];
  placeholder: string;
}) {
  return (
    <>
      <Box sx={{ flex: 1, minWidth: 0, '& .MuiTextField-root': { width: '100%' } }}>
        <SearchField value={params.q} onChange={(q) => set({ q })} placeholder={placeholder} />
      </Box>
      <Stack
        direction="row"
        spacing={1.5}
        sx={{ flexWrap: { xs: 'wrap', md: 'nowrap' }, rowGap: 1.5 }}
      >
        <TextField
          select
          size="small"
          label="Status"
          value={params.status}
          onChange={(e) => set({ status: e.target.value })}
          sx={{ width: { xs: '100%', sm: 160 }, flexShrink: 0 }}
        >
          <MenuItem value="">All</MenuItem>
          {statuses.map((s) => (
            <MenuItem key={s.value} value={s.value}>
              {s.label}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          size="small"
          type="date"
          label="From"
          value={params.from}
          onChange={(e) => set({ from: e.target.value })}
          slotProps={{ inputLabel: { shrink: true } }}
          sx={{ width: { xs: 'calc(50% - 6px)', sm: 160 }, flexShrink: 0 }}
        />
        <TextField
          size="small"
          type="date"
          label="To"
          value={params.to}
          onChange={(e) => set({ to: e.target.value })}
          slotProps={{ inputLabel: { shrink: true } }}
          sx={{ width: { xs: 'calc(50% - 6px)', sm: 160 }, flexShrink: 0 }}
        />
      </Stack>
    </>
  );
}
